<template>
    <div class="upgrade-block">
        <div id="my-subscription" style="margin-top:-105px;padding-top: 105px;">
            <MySubscription />
        </div>
        <!-- <div id="boost-up-upgrade" style="margin-top:-105px;padding-top:105px;">
            <UnlockBoostUp :packages="packages"/>
        </div> -->
        <div
            id="readymade-test-upgrade"
            style="margin-top:-105px;padding-top: 105px;"
        >
            <PackagesList :packages="packages" :route="$route.name"/>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import PackagesList from "@/components/student/UpgradeToGold/PackagesList.vue";
import MySubscription from "@/components/student/UpgradeToGold/MySubscription.vue";
import UnlockBoostUp from "@/components/student/UpgradeToGold/UnlockBoostUp.vue";
import constants from "@/utils/constants.js";
export default {
    name: "UpgradeToGold",
    components: {
        MySubscription,
        UnlockBoostUp,
        PackagesList,
    },
    async mounted() {
        let userToken = JSON.parse(this.$cookies.get('userToken'));
        let auth_token = sessionStorage.getItem("auth_token");
        if ((this.myInstitute.id === constants.ONLINE_INSTITUTE_ID) && userToken && (auth_token != userToken)){    
            await this.delayTime(1000);
        }
		await this.getPackagesList();
        this.scrollToView();
    },
    methods: {
        ...mapActions({
            getPackages: "userStore/getPackages",
            updateTransactionStatus: "userStore/updateTransactionStatus",
            createPackageOrder: "userStore/createPackageOrder",
            me: "userStore/me",
        }),
        scrollToView() {
            let routeName = this.$route.name;
            if(routeName && routeName.includes('masterpyq-upgrade')){
                routeName = 'readymade-test-upgrade';
            }
            const element = document.getElementById(routeName);
            element.scrollIntoView({ behavior: "smooth", block: "start" });
        },
        async getPackagesList() {
            this.$root.showLoader = true;
            return new Promise((resolve,reject)=>{
                 this.getPackages({})
                    .then((response) => {
                        this.$root.showLoader = false;
                        this.packages = (response.product || []).map((pkg) => {
                            pkg.product_list.forEach((p) => {
                                p.pkg = pkg;
                                p.isDisabled = p.isDisabled || p.is_purchased == 1;
                                if (p.is_purchased && !p.parent) {
                                    pkg.product_list.forEach((i) => {
                                        if (i.parent == p.id && !i.isDisabled) {
                                            i.isDisabled = p.isDisabled;
                                        }
                                    });
                                } else if (p.is_purchased) {
                                    pkg.product_list.forEach((i) => {
                                        if (i.id == p.parent && !i.isDisabled) {
                                            i.isDisabled = p.isDisabled;
                                        }
                                    });
                                }
                            });
                            return pkg;
                        });
                        resolve(this.packages)
                        this.me();
                    })
                    .catch((err) => {
                        this.$root.showLoader = false;
                    });
            })
        },
        modifyResetPackageData() {

            this.packages.map((pkg) => {
                 pkg.product_list.map((p) => {
                    return {
                        ...p,
                        ...{
                            description: p.desc,
                            isAdded: false,
                        },
                    };
                });
            });

            this.packages.sort(this.compare);
        },
        compare(a, b) {
            const orderA = parseInt(a.order);
            const orderB = parseInt(b.order);

            let comparison = 0;
            if (orderA > orderB) {
                comparison = 1;
            } else if (orderA < orderB) {
                comparison = -1;
            }
            return comparison;
        },
    },
    data() {
        return {
            packages: [],
        };
    },
    computed: {
        ...mapState("userStore", ["user", "myInstitute"]),
    },
    watch: {
        "$route.name"(val) {
            this.scrollToView();
        },
    },
};
</script>
